<template>
    <!-- BEGIN: Content-->
    <div class="customersList">
      <v-container fluid>

        <v-row>
          <v-col md="12" sm="12" class="d-flex" style="justify-content:space-between">
            <v-breadcrumbs
              :items="breadcrumbs"
              divider="/"
            ></v-breadcrumbs>

            <v-btn
              color="#000000"
              class="white--text"
              depressed
              @click.stop="dialog = true"
            >
              Supplier
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>

          </v-col>
        </v-row>

        <v-row>
          <v-col md="12" sm="12">
            <v-card class="card-shadow py-3">
              <v-data-table
                dense
                :headers="fields"
                :items="suppliers"
                class="elevation-0"
                loading="false"
                loading-text="Loading... Please wait"
              >
                <template v-slot:item.#="{ item }">
                  {{ item.created_at }}
                </template>
                <template v-slot:item.name="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:item.mobile="{ item }">
                  {{ item.mobile }}
                </template>
                <template v-slot:item.email="{ item }">
                  {{ item.email }}
                </template>
                <template v-slot:item.address="{ item }">
                  {{ item.address }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="edit(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteq(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <!-- add user dialog -->
      <v-dialog
        v-model="dialog"
        max-width="600px"
        >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Add Customer</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Name*"
                      v-model="item.name"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Telephone*"
                      v-model="item.telephone"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Email*"
                      v-model="item.email"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Address*"
                      v-model="item.address"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="create"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- end user -->

      <!-- user update modal-->
      <v-dialog
        v-model="updatedialog"
        max-width="600px"
        >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Update Customer</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Name*"
                      v-model="item.updatename"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Telephone*"
                      v-model="item.updatetelephone"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Email*"
                      v-model="item.updateemail"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                  >
                    <v-text-field
                      label="Address*"
                      v-model="item.updateaddress"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="updatedialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="update"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- update user -->

    </div>

</template>

<script>
import axios from 'axios'
import { Modal } from 'bootstrap'
import {ability} from '../../services/ability'

export default {
    name:"Suppliers",
    data(){
        return {
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          search:null,
          valid: true,
          searchrole:null,
          dialog: false,
          searchcountry: null,
          updatedialog: false,
          breadcrumbs: [
            {
              text: 'Dashboard',
              disabled: false,
              href: '/',
            },
            {
              text: 'Suppliers',
              disabled: false,
              href: '',
            },
          ],
          fields: [
             {
              text: '#',
              align: 'start',
              value: 'created_at',
            },
            { text: 'Name', value: 'name' },
            { text: 'Telephone', value: 'mobile' },
            { text: 'Email', value: 'email' },
            { text: 'Address', value: 'address' },
            { text: 'Action', value: 'action' },
           ],
          item:{
                name:"",
                telephone:"",
                email: "",
                address:"",

                updatename:"",
                updatetelephone:"",
                updateemail: "",
                updateaddress:"",

                updateID: "",
                _method:"patch"
            },
            loading: false,
           disabled: false,
           isBusy: false,
            updateModal: null
        }
    },
    beforeMount() {
      if(!ability.can('inventory-management', 'all')) {
        this.$router.push({ name: 'Pos' })
        return
      }
    },
    mounted(){
      if(!this.suppliers || this.suppliers.length == 0) {
        this.getSuppliers()
      }
    },
    computed: {
      suppliers() {
        return this.$store.state.suppliers
      },
    },
    methods:{
      async getSuppliers(){
        this.isBusy = true
        await axios.get('/suppliers').then(response=>{
            this.$store.state.suppliers = response.data.suppliers
        }).catch(error=>{
            console.log(error)
        })
      },
       async create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('name',this.item.name)
            fd.append('telephone',this.item.telephone)
            fd.append('email',this.item.email)
            fd.append('address',this.item.address)

            await axios.post('/suppliers', fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              if(response.data.status === parseInt(200))
                this.$toast.success("Supplier added successfully",'Success',{position: 'topRight',timeout: 7000,})
                this.getSuppliers()
                this.clear()
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

        }

        },
        clear () {
          this.$refs.form.reset()
        },
        async update(){

          if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('name',this.item.updatename)
            fd.append('telephone',this.item.updatetelephone)
            fd.append('email',this.item.updateemail)
            fd.append('address',this.item.updateaddress)
            fd.append('_method',this.item._method)

            await axios.post(`/suppliers/${this.item.updateID}`, fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              if(response.data.status === parseInt(200))
                this.$toast.success("Supplier updated successfully",'Success',{position: 'topRight',timeout: 7000,})
                this.updatedialog = false
                this.getSuppliers()
              this.clear()
              this.item.updateID = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
      async edit(id) {
        let index = this.suppliers.filter(item => item.id === id );
        this.item.updatename = index[0].name
        this.item.updatetelephone = index[0].telephone
        this.item.updateemail = index[0].email
        this.item.updateaddress = index[0].address

        this.item.updateID = index[0].id
        this.updatedialog = true
      },
      deleteq(id){
            if(confirm("Are you sure to delete customer ?")){
                axios.delete(`/suppliers/${id}`).then(response=>{
                  this.$toast.success('Supplier deleted successfully','Success',{position: 'topRight',timeout: 7000,})
                    this.getSuppliers()
                }).catch(error=>{
                    console.log(error)
                })
            }
        }

    }
}
</script>